import * as React from 'react';
import { EMPTY_TEXT } from '@mitchell/react.component.ux';
import { TranslationService } from "../../../common";
import { IntelligentAssignmentSummary } from '../../constants';
import { IntelligentPhotoCaptureEstimatorLabelTypeCode } from '../../enums';
import { getAlbumHeader, getContentTypeToLabelMapping, getPrtcDescriptionFromData } from '../../utilities';
import { StyledImageLabelHeading, StyledImageLabelSection, StyledImageLabelValue } from './IntelligentPhotoCaptureEstimatorThumbnailGallery.style';
export const IntelligentPhotoCaptureEstimatorLabelSectionComponent = ({ activeVisibleAttachment, countryCode, replacementByFileId, prtcDetailsData }) => {
    const translateFn = TranslationService.translate;
    const { useMemo } = React;
    const selectedImageMappings = useMemo(() => {
        if (!activeVisibleAttachment) {
            return [];
        }
        // For replaced images (upload/retake), hide label until backend metadata is refreshed.
        if (activeVisibleAttachment.fileId && replacementByFileId.has(activeVisibleAttachment.fileId)) {
            return [];
        }
        const contentTypeToLabelMap = getContentTypeToLabelMapping(countryCode);
        const mappings = (activeVisibleAttachment.foldersModelInfo || []).map((folderModel) => {
            const normalizedFolderTypeCode = (folderModel.folderTypeCode || EMPTY_TEXT).toUpperCase();
            let labelName = EMPTY_TEXT;
            if (folderModel.contentType) {
                const mappedLabel = contentTypeToLabelMap[folderModel.contentType];
                labelName = mappedLabel ? translateFn(mappedLabel) : labelName;
            }
            if (folderModel.labelTypeCode === IntelligentPhotoCaptureEstimatorLabelTypeCode.PRTC && folderModel.text) {
                labelName = getPrtcDescriptionFromData(folderModel.text, prtcDetailsData) || labelName;
            }
            return {
                group: getAlbumHeader(normalizedFolderTypeCode),
                label: labelName
            };
        });
        return mappings;
    }, [activeVisibleAttachment, countryCode, prtcDetailsData, replacementByFileId]);
    return (React.createElement(StyledImageLabelSection, null,
        React.createElement(StyledImageLabelHeading, null, translateFn(IntelligentAssignmentSummary.LABEL_FIELD_HEADING)),
        selectedImageMappings.map((mapping, index) => {
            return (React.createElement(StyledImageLabelValue, { id: `${IntelligentAssignmentSummary.MAPPING_LABEL_ID_PREFIX}-${index}`, key: `${IntelligentAssignmentSummary.MAPPING_LABEL_ID_PREFIX}-${index}` }, mapping.label && mapping.group && `${mapping.group} - ${mapping.label}`));
        })));
};
//# sourceMappingURL=IntelligentPhotoCaptureEstimatorLabelSectionComponent.js.map